import { Button } from "@/components/ui/button";
import { House, RefreshCw, FileText } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function SaferHomesSmarterDecisions() {
  return <section data-section-id="256652" id="safer-homes-smarter-decisions" className="relative bg-background text-foreground py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-primary/5 pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center text-center">
        {}
        <div className="mb-8 p-4 bg-muted rounded-2xl shadow-sm">
          <span className="text-xs font-bold font-default tracking-widest text-destructive uppercase">Independent home security reviews</span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default mb-6 tracking-tighter text-primary">
          Safer Homes. <span className="text-primary/80">Smarter Decisions.</span>
        </h1>
        
        <p className="text-lg md:text-xl max-w-2xl mx-auto mb-10 text-muted-foreground font-default leading-relaxed">
          Find the Best House Security & Safety Products for Your House. Compare systems, cameras, smart locks, and alarms with expert-tested reviews.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <Button asChild variant="secondary" size="lg" className="rounded-lg shadow-md bg-secondary text-secondary-foreground hover:opacity-90 transition-opacity">
            <Link to="/HomePage">
              <House className="mr-2 size-5" />
              Compare Products
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="rounded-lg bg-transparent border-primary/20 text-primary hover:bg-muted shadow-sm transition-colors">
            <Link to="/HomePage">
              <RefreshCw className="mr-2 size-5" />
              Browse Reviews
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="rounded-lg bg-transparent border-transparent text-muted-foreground hover:text-primary shadow-sm transition-colors">
            <Link to="/affiliate-disclosure">
              <FileText className="mr-2 size-5" />
              Affiliate Disclosure
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}